import styled from 'astroturf';
import React from 'react';

import Hero from './index';

const HeroContainer = /*#__PURE__*/styled("div", null, {
  displayName: "HeroContainer",
  styles: require("./Accessory-HeroContainer.module.css"),
  attrs: null,
  vars: []
});

interface Props {
  children?: React.ReactNode;
  renderBackground?(props: { className: string }): React.ReactNode;
}

export default function IndexHero(props: Props) {
  return (
    <Hero short renderBackground={props.renderBackground}>
      <HeroContainer>{props.children}</HeroContainer>
    </Hero>
  );
}
